export default __webpack_public_path__ + "4497eedaf0c8cde8fa881f47a8ba196b.png";